<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col>
        <relatorio-pedidos-list-filtro @search="handleGetPedidos" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <relatorio-pedido-geral ref="cotas" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import RelatorioPedidosListFiltro from '@/components/patio/relatorioPedidos/RelatorioPedidosListFiltro.vue'
import RelatorioPedidoGeral from '@/components/patio/relatorioPedidos/RelatorioPedidoGeral'

import { data } from './_data'

export default {
  name: 'RelatorioPedidos',

  components: {
    RelatorioPedidosListFiltro,
    RelatorioPedidoGeral,
  },
  data,
  computed: {
    ...mapState('auth', ['empresaAtual']),
    ...mapState('relatorioPedidos', ['params']),
  },
  methods: {
    async handleGetPedidos() {
      await this.$refs.cotas.atualizarEstrutura(this.params)
    },
  },
}
</script>
